import React,{useState,useEffect} from 'react';
import { Table } from "react-bootstrap";
import "./styles.css";                                                                                                                                                                                                                                                                                                                          
import AdminDashboard from "../AdminDashboard"
import axios from "axios";

const url = "https://www.bitmasta.io/php/admin_pass.php";
export default function Referral() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
   
    useEffect(()=>{
        const fetchData = async () => {
            let formData = new FormData();
            formData.append("Users",true)
            try{
           const res = await axios.post(url,formData)
              if(res.data.status === "Users Found"){
                setLoading(false)
                setUsers(res.data.data)
              }
              else{
                setLoading(false)
                setUsers([])
              }
            }
            catch(_er){
           console.log(_er)
            }
          }
        
          fetchData()
        },[])
    return (
        <AdminDashboard>
            { !loading ?
                users.length > 0 ?
            <Table responsive>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email Address</th>
                        <th>Phone Number</th>
                        <th>Referral Code</th>
                        <th>Number Referred</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        users.filter(user=>user.Referrals >0).map((user,i)=>(
                            <tr key={i}>
                            <td className="">{user.Name}</td>
                            <td className="">
                                <a href={`mailto:${user.Email}`} className="blackText">
                                    {user.Email}
                                </a>
                                </td>
                            <td>
                                <a href="tel:+2348145738757" className="blackText" target="blank">
                                    {user.Phone}
                                </a>
                            </td>
                            <td className="">{user.code}</td>
                            <td className="lightBlueBg">{user.Referrals}</td>
                        </tr>
                        ))
                    }
                    
                </tbody>
            </Table>
                
                :<p className="text-center">No User found</p>
                :<p className="text-center">loading...</p>}
        </AdminDashboard>
    )
}
